/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef, useState } from "react";
import LuckyDrawComponent from "./luckyDraw.component";
import { useSelector } from "react-redux";
import moment from "moment";
import luckyDrawV2Api from "app/api/luckyDrawV2";

export default function LuckyDrawContainer({ id , isTemplateEditor, getTranslation }) {
  const { isVisible, content } = useSelector(state => isTemplateEditor
    ? state.products.template.workspaceSetting.setting.components[id]
    : state.productPage.components[id]);

  const [isLoading, setIsLoading] = useState(false);
  const [luckyDraw, setLuckyDraw] = useState(null);
  const [countdown, setCountdown] = useState({
    day: 0,
    hour: 0,
    min: 0,
    sec: 0,
  });
  const [drawCountdown, setDrawCountdown] = useState({
    day: 0,
    hour: 0,
    min: 0,
    sec: 0,
  });

  const intervalRef = useRef(null);
  const drawIntervalRef = useRef(null);

  useEffect(() => {
    if (content.id) {
      setIsLoading(true);

      luckyDrawV2Api
        .getLuckyDrawCardDetail({ id: content.id })
        .then((res) => {
          setLuckyDraw(res.data);
        })
        .catch((res) => {})
        .finally(() => {
          setIsLoading(false);
        });
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [content]);

  useEffect(() => {
    if (luckyDraw) {
      if (luckyDraw.version === "current") {
        let isStart = moment().isAfter(
          moment.utc(luckyDraw.join_open_at).local()
        );
        if (!isStart) {
          checkJoinStartCountdown(luckyDraw);
        } else {
          checkJoinCloseCountdown(luckyDraw);
        }
      } else {
        if (!!luckyDraw.end_at) {
          let isJoinEnd = moment().isAfter(
            moment.utc(luckyDraw.end_at).local()
          );
          if (!isJoinEnd) {
            intervalRef.current = setInterval(() => {
              let tempCountdown = updateCountdown({
                targetDate: moment.utc(luckyDraw.end_at).local(),
              });
              setCountdown(tempCountdown);

              let countdownEnd =
                !tempCountdown.day &&
                !tempCountdown.hour &&
                !tempCountdown.min &&
                !tempCountdown.sec;
              if (countdownEnd && intervalRef.current) {
                clearInterval(intervalRef.current);
              }
            }, 1000);
          }
        }
      }
    }

    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
      }
    };
  }, [luckyDraw]);

  const checkJoinStartCountdown = (luckyDraw) => {
    intervalRef.current = setInterval(() => {
      let tempCountdown = updateCountdown({
        targetDate: moment.utc(luckyDraw.join_open_at).local(),
      });
      setCountdown(tempCountdown);

      let countdownEnd =
        !tempCountdown.day &&
        !tempCountdown.hour &&
        !tempCountdown.min &&
        !tempCountdown.sec;
      if (countdownEnd && intervalRef.current) {
        clearInterval(intervalRef.current);
      }

      if (countdownEnd && luckyDraw.join_close_at) {
        checkJoinCloseCountdown(luckyDraw);
      }
    }, 1000);
  };

  const checkJoinCloseCountdown = (luckyDraw) => {
    if (!!luckyDraw.join_close_at) {
      let isJoinEnd = moment().isAfter(
        moment.utc(luckyDraw.join_close_at).local()
      );
      if (!isJoinEnd) {
        intervalRef.current = setInterval(() => {
          let tempCountdown = updateCountdown({
            targetDate: moment.utc(luckyDraw.join_close_at).local(),
          });
          setCountdown(tempCountdown);

          let countdownEnd =
            !tempCountdown.day &&
            !tempCountdown.hour &&
            !tempCountdown.min &&
            !tempCountdown.sec;
          if (countdownEnd && intervalRef.current) {
            clearInterval(intervalRef.current);
          }
        }, 1000);
      }
    }
  };

  useEffect(() => {
    if (luckyDraw && luckyDraw.version === "current") {
      let isJoinEnd = luckyDraw.join_close_at
        ? moment().isAfter(moment.utc(luckyDraw.join_close_at).local())
        : false;
      if (
        (!!luckyDraw.participant_joined || isJoinEnd) &&
        luckyDraw.join_end_action === 1 &&
        luckyDraw.draw_at &&
        moment().isBefore(moment.utc(luckyDraw.draw_at).local())
      ) {
        drawIntervalRef.current = setInterval(() => {
          let tempCountdown = updateCountdown({
            targetDate: moment.utc(luckyDraw.draw_at).local(),
          });
          setDrawCountdown(tempCountdown);

          let countdownEnd =
            !tempCountdown.day &&
            !tempCountdown.hour &&
            !tempCountdown.min &&
            !tempCountdown.sec;
          if (countdownEnd && drawIntervalRef.current) {
            clearInterval(drawIntervalRef.current);
          }
        }, 1000);
      }
    }

    return () => {
      if (drawIntervalRef.current) {
        clearInterval(drawIntervalRef.current);
      }
    };
  }, [luckyDraw]);

  const updateCountdown = ({ targetDate }) => {
    var seconds = Math.floor(
      moment.duration(targetDate.diff(moment())).asSeconds()
    );
    var minutes = Math.floor(seconds / 60);
    var hours = Math.floor(minutes / 60);
    var days = Math.floor(hours / 24);

    return {
      day: days > 0 ? days : 0,
      hour: hours - days * 24,
      min: minutes - hours * 60,
      sec: seconds - minutes * 60,
    };
  };

  return (
    isVisible && (
      <LuckyDrawComponent
        luckyDraw={luckyDraw}
        isLoading={isLoading}
        countdown={countdown}
        drawCountdown={drawCountdown}
        getTranslation={getTranslation}
      />
    )
  );
}
